import { Component, computed, inject, input, output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SafeHtmlPipe } from '../../core/pipes/safe-html.pipe';
import { DIALOG_CLOSE, DISMISS_NOTIFICATIONS } from '../../core/models/tokens';
import { NotificationPreamble, NotificationStep } from '../../core/models/notification.model';
import { faBellSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'wf-notification-layout',
  standalone: true,
  imports: [FontAwesomeModule, RouterModule, SafeHtmlPipe],
  templateUrl: './notification-detail-layout.component.html',
  styleUrl: './notification-detail-layout.component.css'
})
export class NotificationLayoutComponent {
  private readonly router = inject(Router);
  private readonly closeDialog = inject(DIALOG_CLOSE, { optional: true });
  private readonly dismissNotifications = inject(DISMISS_NOTIFICATIONS, { optional: true });
  readonly headerTitle = input.required<string>();
  readonly preambles = input<NotificationPreamble[]>([]);
  readonly steps = input<NotificationStep[]>([]);
  readonly ids = input.required<Partial<Record<'alerts' | 'notifications', number[]>>>();
  readonly ctaLabel = input.required<string>();
  readonly ctaRoute = input.required<string>();
  readonly closingText = input<string>('');
  readonly usageHighlight = input<string>('');
  readonly isOpen = input<boolean>(false);
  readonly onClose = output<void>();
  readonly dismissIcon = faBellSlash;
  readonly canDismiss = computed(() => {
    return this.router.url.includes('recent');
  })

  handleRouteClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    event.preventDefault();
    if (target.tagName === 'A' && target.hasAttribute('data-route')) {
      event.preventDefault();

      const route = target.getAttribute('data-route') as string;
      if (route) {
        this.router.navigateByUrl(route);
      }
    }
  }

  handleClose() {
    this.closeDialog?.();
  }

  handleDismiss() {
    const currentIds = this.ids();
    const alertIds = currentIds?.alerts ?? [];
    const notificationIds = currentIds?.notifications ?? [];

    this.dismissNotifications?.(alertIds, notificationIds);
  }
}
